import React from "react";

const GREEN = "#5DFD93";
const RED = "red";

const norm = (s) => (s || "").toString().trim().toLowerCase();

const isNeutralLabel = (label) =>
  ["trips", "ee no.", "ee no", "ee number", "ee #"].includes(norm(label));

const isCancellationLabel = (label) => {
  const l = norm(label);
  return (
    l === "total" ||
    l === "early" ||
    l === "late" ||
    /^after\s+cut[-\s]?off$/.test(l)
  );
};

const isReverseSignLabel = (label) =>
  ["single trips", "adhocs"].includes(norm(label)) || isCancellationLabel(label);

const getVarianceColor = (label, variance, theme_color) => {
  if (variance == null || variance === 0) return theme_color;
  if (isNeutralLabel(label)) return theme_color;
  if (isReverseSignLabel(label)) return variance < 0 ? GREEN : RED;
  return variance > 0 ? GREEN : RED;
};

export const renderCards = (metrics, theme_color) =>
  metrics.map(({ label, value, variance }) => {
    const showVariance = variance != null;
    const formatted = showVariance ? `${variance > 0 ? "+" : ""}${variance}%` : "";
    const color = getVarianceColor(label, variance, theme_color);

    return (
      <div
        key={label}
        className="flex flex-col items-center justify-center text-center h-12 w-full"
      >
        <p className="text-xl font-medium" style={{ color: theme_color }}>
          {value}{" "}
          <span className="text-sm font-thin" style={{ color }}>
            {formatted}
          </span>
        </p>
        <p className="font-normal" style={{ color: theme_color }}>
          {label}
        </p>
      </div>
    );
  });
